import gql from "graphql-tag";

export default gql`
  mutation createGraphicSet($customerId: ID, $graphicSetInput: GraphicSetInputInput) {
    createGraphicSet(customerId: $customerId, graphicSetInput: $graphicSetInput) {
      id
      customerId
    }
  }
`;
